import {createReducer, on, Action} from '@ngrx/store';
import {AuthActions} from '../actions';
import {
  initialAuthState, initialLoginFormData, LINGUE, USER_ROLES,
} from '../../../@types';
import {LoginFormData} from '../../../../features/login/@types';
import {TorneiActions} from '../../../../features/tab-tornei/store/actions';

export interface AuthState {
  loading: boolean;
  isAuthenticated: boolean;
  loginFormData: LoginFormData;
  userAuthData: UserAuthData;
  anniTornei: string[];
}

export interface UserAuthData {
  id: number;
  Nome: string;
  Cognome: string;
  Alias: string;
  Telefono: string;
  Email: string;
  DataDiNascita: string;
  Username: string;
  role: USER_ROLES;
  DB_Name: string;
  Token: string;
  UltimoAccesso?: null;
  UltimoLogin?: null;
  Lingua?: LINGUE;
}

const reducer = createReducer(
  initialAuthState,
  on(AuthActions.Login, (state) => ({
    ...state,
    loading: true
  })),
  on(AuthActions.LoginSuccess, (state, {userAuthData, loginFormData}) => ({
    ...state,
    // loading: false, // Perche lo imposta a falso poi InitDataSuccess o Error
    isAuthenticated: true,
    userAuthData,
    loginFormData
  })),
  on(AuthActions.LoginError, (state, error) => ({
    ...state,
    loading: false
  })),

  on(AuthActions.InitData, (state) => ({
    ...state,
    loading: true
  })),
  on(AuthActions.InitDataSuccess, (state, {anniTornei}) => ({
    ...state,
    loading: false,
    anniTornei
  })),
  on(TorneiActions.Detail.LoadAnniTorneiSuccess, (state, {anniTornei}) => ({
    ...state,
    anniTornei
  })),
  on(AuthActions.InitDataError, (state) => ({
    ...state,
    loading: false
  })),

  on(AuthActions.Logout, state => ({
    ...state,
    ...initialAuthState,
    // Controllo se lasciare memorizzati i dati di accesso
    loginFormData: (state.loginFormData.rememberMe) ? state.loginFormData : initialLoginFormData
  }))
);

export const authReducer = (
  state: AuthState | undefined,
  action: Action
): AuthState => reducer(state, action);
